import firebase from 'firebase';
import { v4 as uuid } from 'uuid';

export const saveBoard = async (data) => {
  const db = firebase.firestore();
  await db.collection('boards').doc(uuid()).set(data);
  return true;
}

export const listBoards = async () => {
  const db = firebase.firestore();
  const data = await db.collection('boards').get();
  return (data?.docs || []).map(doc => ({ ...doc.data(), id: doc.id }));
}

export const deleteBoard = async (id) => {
  const db = firebase.firestore();
  await db.collection('boards').doc(id).delete();
  return true;
}
